import React from 'react';
import {
  TableRow,
  TableCell,
  Tooltip,
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';

import WarningDescription from '../pwtWarnings/table/WarningDescription';
import ExpandableSectionWithTable from './components/ExpandableSectionWithTable';
import { PrivateWealthWarningChip } from '../shared/Chips';

const WarningsSection = ({
  warnings,
  setWarnings,
  open,
  fetching,
  from,
  hasChanges,
  ...props
}) => {
  const updateWarningStatus = async (warning, status) => {
    setWarnings(prevState => {
      const newState = prevState.map(obj => {
        if (obj.id === warning.id) {
          return { ...obj, status, modified: true };
        }
        return obj;
      });
      return newState;
    });
  };

  const headCells = [
    { id: 'status', numeric: false, disablePadding: false, label: 'Status', sortable: true },
    { id: 'description', numeric: false, disablePadding: false, label: 'Description', sortable: true },
    { id: 'type_of_warning', numeric: false, disablePadding: false, label: 'Type', sortable: true },
    { id: 'options', numeric: false, disablePadding: false, label: null },
  ];

  const RowRenderer = (row, _isSelected, index, _handleCheck) => (
    <TableRow
      hover
      tabIndex={-1}
      key={row.id}
      style={{ cursor: 'pointer' }}
      onClick={() => (row.id)}
    >
      <TableCell>
        <PrivateWealthWarningChip type={row.status} />
      </TableCell>
      <TableCell>
        <WarningDescription warning={row} from={from} />
      </TableCell>
      <TableCell>
        <PrivateWealthWarningChip type={row.type_of_warning} />
      </TableCell>
      <TableCell style={{ display: 'flex' }}>
        <Tooltip title={'Ignore'}>
          <IconButton edge='end' aria-label='ignore' onClick={() => updateWarningStatus(row, 'ignored')}>
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title={'Resolve'}>
          <IconButton edge='end' aria-label='resolve' onClick={() => updateWarningStatus(row, 'resolved')} disabled={!hasChanges}>
            <CheckIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );

  return (
    <ExpandableSectionWithTable
      title='Warnings'
      open={open}
      fetching={fetching}
      headCells={headCells}
      rows={warnings}
      RowRenderer={RowRenderer}
    />
  );
};

export default WarningsSection;
